// src/Components/Structural/TopBar/LanguageSelector.js

import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage, selectCurrentLanguage } from '../../../Redux/reducers/languageReducer';
import englishFlag from '../../../Assets/flags/EN.webp';
import dutchFlag from '../../../Assets/flags/BE.webp';
import frenchFlag from '../../../Assets/flags/FR.webp';
import './css/languageSelector.css';

const languageOptions = [
  { code: 'en', name: 'English', flag: englishFlag },
  { code: 'nl', name: 'Nederlands', flag: dutchFlag },
  { code: 'fr', name: 'Français', flag: frenchFlag },
];

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectCurrentLanguage);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedLanguage = languageOptions.find((lang) => lang.code === currentLanguage) || languageOptions[1];

  const handleLanguageSelect = (lang) => {
    dispatch(setLanguage(lang.code));
    localStorage.setItem('preferredLanguage', lang.code);
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="topbar-language-selector" ref={dropdownRef}>
      <div
        className="topbar-language-toggle"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        title={selectedLanguage.name}
      >
        <div className="topbar-language-flag">
          <img
            src={selectedLanguage.flag}
            alt={selectedLanguage.name}
            className="topbar-language-flag-img"
          />
        </div>
        <span className="topbar-language-name">{selectedLanguage.name}</span>
      </div>

      {isDropdownOpen && (
        <div className="topbar-language-dropdown">
          {languageOptions.map((lang) => (
            <div
              key={lang.code}
              className={`topbar-language-option ${lang.code === selectedLanguage.code ? 'selected' : ''}`}
              onClick={() => handleLanguageSelect(lang)}
            >
              <img
                src={lang.flag}
                alt={lang.name}
                className="topbar-language-option-flag"
              />
              <span className="topbar-language-option-name">{lang.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
